"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newsTypeList = exports.newsListMenhu = exports.getnewsInfo = exports.getFrontAndNext = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取新闻分类列表
 */
var newsTypeList = exports.newsTypeList = function newsTypeList(query) {
  return _api.default.request({
    url: '/system/web/newsTypeList',
    method: 'get',
    params: query
  });
};

/**
 * 描述 获取新闻列表
 */
var newsListMenhu = exports.newsListMenhu = function newsListMenhu(query) {
  return _api.default.request({
    url: '/system/web/newsList',
    method: 'get',
    params: query
  });
};

/**
 * 描述 获取新闻详情
 */
var getnewsInfo = exports.getnewsInfo = function getnewsInfo(query) {
  return _api.default.request({
    url: '/system/web/newsInfo',
    method: 'get',
    params: query
  });
};

/**
 * 描述 获取新闻上一条下一条
 */
var getFrontAndNext = exports.getFrontAndNext = function getFrontAndNext(query) {
  return _api.default.request({
    url: '/system/web/getFrontAndNext',
    method: 'get',
    params: query
  });
};